import React, { Component } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Dropdown, DropdownItem, DropdownMenu, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import CSelectContent from "./CSelectContent"
import CSelectButton from "./CSelectButton"

class CSelect extends Component {

  state = {
    isOpen: false,
    activeTab: this.props.activeTab,
    search: ""
  }

  toggle = () => {
    const { isOpen } = this.state

    this.setState({
      isOpen: !isOpen,
      activeTab: this.props.activeTab,
      search: ""
    })
  }

  onChange = (value, currentTab) => {
    this.props.onChange(value, currentTab)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.activeTab !== this.props.activeTab) {
      this.setState({ activeTab: this.props.activeTab })
    }
  }

  onClickSelect = (isEval, options = [], values = [], currentTab) => {
    if (isEval) {
      this.onChange(values.filter(i => !options.some(o => o.value === i.value)), currentTab)
    } else {
      const arr = [...values]
      options.forEach(i => {
        if (!values.some(v => v.value === i.value)) {
          arr.push(i)
        }
      })
      this.onChange(arr, currentTab)
    }
  }

  render() {
    const { tabs, value } = this.props

    const getAsArray = tabs => {
      if (!tabs) return []

      return Array.isArray(tabs)
        ? tabs
        : [tabs]
    }

    const parsedTabs = getAsArray(tabs)
    const parsedValue = getAsArray(value)

    const currentTab = parsedTabs.find(i => i.tabKey === this.state.activeTab)

    const filteredOptions = (currentTab?.options || []).filter(({ label }) => label.toLowerCase().includes(this.state.search.toLowerCase()))

    const activeValuesOnTab = this.props.activeTab === this.state.activeTab ? parsedValue : []

    const getIsEval = (a1, a2) => {
      for (let i1 of a1) {
        if (!a2.some(i => i.value === i1.value)) return false;
      }
      return true
    }

    const isEval = getIsEval(filteredOptions, activeValuesOnTab)

    return (
      <StyledContainer
        className={this.props.className || ""}
        isOpen={this.state.isOpen}
        style={{ width: this.props.width || "100%" }}
        toggle={this.toggle}
      >
        <CSelectButton
          value={value}
          isMulti={Array.isArray(value)}
          onChange={e => this.onChange(e, currentTab)}
          isOpen={this.state.isOpen}
        />
        <DropdownMenu>
          {parsedTabs.length > 1 &&
          <Nav tabs className="nav-tabs-custom nav-justified">
            {parsedTabs.map(({ label, tabKey }, idx) =>
              <NavItem key={label.toString() + idx}>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: tabKey === this.state.activeTab
                  })}
                  onClick={() => this.setState({ activeTab: tabKey })}
                >
                  {label}
                </NavLink>
              </NavItem>)}
          </Nav>}
          <div className="cselect__search">
            <input placeholder="Search..." type="text" aria-describedby="Search..." autoFocus tabIndex="0"
                   onChange={e => this.setState({ search: e.target.value })} value={this.state.search} />
          </div>
          <CSelectContent
            options={filteredOptions}
            isMulti={currentTab?.isMulti}
            onChange={e => this.onChange(e, currentTab)}
            value={activeValuesOnTab}
          />
          {currentTab?.isMulti && filteredOptions?.length > 0 &&
          <DropdownItem toggle={false} className="cselect-select-all" onClick={() => this.onClickSelect(isEval, filteredOptions, activeValuesOnTab, currentTab)}>
            {isEval
              ? `Clear all ${this.state.search.length > 0 ? '(Filtered)' : ''}`
              : `Select all ${this.state.search.length > 0 ? '(Filtered)' : ''}`
            }
          </DropdownItem>}
        </DropdownMenu>
      </StyledContainer>
    )
  }
}

const StyledContainer = styled(Dropdown)`

  .dropdown-menu {
    animation-duration: 0s !important;
    margin-top: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    padding: 0;
    right: -40px;

    .cselect__search {
      width: 100%;
      position: relative;
      border-bottom: 1px solid #ccc;

      input {
        background: none;
        height: 38px;
        padding: 0 24px;
        width: 100%;
        outline: 0;
        border: 0;
      }
    }

    .cselect-select-all {
      padding: 12px 24px;
      background: #f8f8fb;
      color:rgb(73, 80, 87);
      cursor: pointer;
      transition: .2s ease;
      border-top: 1px solid #ccc;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      &:hover {
        color: #556ee6
      }
    }
  }

`

CSelect.propTypes = {
  tabs: PropTypes.any.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func,
  activeTab: PropTypes.string,
  width: PropTypes.any,
  className: PropTypes.string
}

export default (CSelect)
